module.exports = __webpack_public_path__ + "static/media/loader.42102c94.svg";